// React
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import { Grid, Box, Button, Container, Divider } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
// Service
import { get, post, put, gen_link } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
import { DiscountState, DiscountSchema, DiscountFormFields } from "./Discount.utils";
// Styles
import { StyledDrawerForm } from "../../../configs/GoStyles";
//Third party
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import GoForm from "../../../components/Inputs/GoForm";
import PermissionConstants from "../../../configs/PermissionConstants";
import usePermissions from "../../../hooks/usePermissions";
import DiscountLines from "./DiscountLines";

// import DiscountLines from "./DiscountLines";

const Discount = ({ id, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [discount, setDiscount] = useState(DiscountState);
    const [schema, setSchema] = useState(DiscountSchema);
    const [formFields, setFormFields] = useState(DiscountFormFields);
    const [discountLines, setDiscountLines] = useState([]);
    const [discountId, setDiscountId] = useState(id);

    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name && (field.type === "select" || field.type === "autocomplete")
                    ? { ...field, options: options }
                    : field
            )
        );
    };

    const handleValueChange = (e) => {
        setDiscount((prevState) => {
            return { ...prevState, [e.target.name]: e.target.value }
        })
    };

    const handleSubmit = async (values) => {
        spinService.on();
        const isNewDiscount = values.id === undefined;
        const url = isNewDiscount ? EntityConstants.DISCOUNTS : EntityConstants.DISCOUNTS + `/${values.id}`;
        const method = isNewDiscount ? post : put;
        const response = await method(url, { discount: values });
        if ([200, 201].indexOf(response.status) > -1) {
            const data = await response.json();
            toast.success(isNewDiscount ? MessageContants.DISCOUNT_CREATED : MessageContants.DISCOUNT_UPDATED);
            setDiscount(data);
            setDiscountId(data.id);
        }
        spinService.off();
    };

    useEffect(() => {
        const fetchDiscount = async (id) => {
            const response = await get(EntityConstants.DISCOUNTS + `/${id}`)
            const data = await response.json();
            setDiscount(data);
        };
        id !== undefined && fetchDiscount(id);
    }, [id]);

    useEffect(() => {
        const fetchSchools = async () => {
            const response = await get(EntityConstants.SCHOOLSBYCOMPANIES, "max=all");
            const data = await response.json();
            attachOptions("school_id", data);
        };
        fetchSchools();
    }, []);

    useEffect(() => {
        const fetchStudentsBySchool = async (school_id) => {
            const response = await get(EntityConstants.STUDENTS, `max=all&school_id=${school_id}`)
            const data = await response.json();
            attachOptions("student_id", data);
        };
        discount.school_id && fetchStudentsBySchool(discount.school_id);
    }, [discount.school_id]);

    useEffect(() => {
        const fetchInvoicesByStudent = async () => {
            const response = await get(EntityConstants.ACTIVE_INVOICES_BY_STUDENT + `/${discount.student_id}`)
            const data = await response.json();
            if (data.length === 0) {
                toast.error("No invoice found")
            } else {
                let from_dates = []
                data.map((ih) => from_dates.push({ id: ih.invoice_date }));
                let end_dates = []
                data.map((ih) => end_dates.push({ id: ih.due_date }));
                attachOptions("from_date", from_dates);
                attachOptions("end_date", end_dates);
                setDiscountLines(data)
            }
        };
        discount.student_id && fetchInvoicesByStudent();
    }, [discount.student_id, discountId]);

    return (
        <Container>
            <Formik
                enableReinitialize
                initialValues={discount}
                validationSchema={schema}
                onSubmit={(values) => handleSubmit(values)}
            >
                {({
                    values,
                    touched,
                    errors,
                    handleChange,
                    handleSubmit,
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <StyledDrawerForm>
                            <Grid
                                container
                                // maxWidth="md"
                                rowSpacing={1}
                                columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                            >
                                {formFields.map((formField, index) => {
                                    return (
                                        <Grid key={index} item xs={12} sm={12} md={4} lg={4}>
                                            <GoForm
                                                config={formField}
                                                values={values}
                                                touched={touched}
                                                errors={errors}
                                                handleChange={(e) => { handleChange(e); handleValueChange(e); }}
                                            />
                                        </Grid>
                                    );
                                })}
                            </Grid>
                            <Box sx={{ p: 2, textAlign: "right" }}>
                                <Button
                                    variant="contained"
                                    color="error"
                                    startIcon={<Iconify icon="eva:close-circle-outline" />}
                                    onClick={() => onClose()}
                                >
                                    Close
                                </Button>
                                &nbsp;&nbsp;
                                {((values.id === undefined && permissions.has(PermissionConstants.DISCOUNT_CREATE))) &&
                                    <Button
                                        variant="contained"
                                        startIcon={<Iconify icon="eva:save-fill" />}
                                        type="submit"
                                    >
                                        {values.id === undefined ? 'Submit' : 'Update'}
                                    </Button>
                                }
                            </Box>
                        </StyledDrawerForm>
                    </Form>
                )}
            </Formik>
            <Divider />
            <br />
            {discountLines.length > 0 && <DiscountLines discountLines={discountLines} />}
        </Container>
    );
};

Discount.propTypes = {
    id: PropTypes.number,
    onClose: PropTypes.any,
};

export default Discount;